"use strict";

var _require = require('ramda'),
    find = _require.find,
    propEq = _require.propEq,
    pipe = _require.pipe;

var CURRENCIES = require('./currencies');

var formatPrice = require('./formatPrice'); // coins :: Number -> Number -> Number


function coins() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var amount = arguments.length > 1 ? arguments[1] : undefined;
  return amount / ratio;
} // currencySymbol :: String -> Boolean -> String -> String


function currencySymbol(symbol, prepend, amount) {
  return prepend ? "".concat(symbol, " ").concat(amount) : "".concat(amount, " ").concat(symbol);
} // toLocaleCurrency :: Currency -> Number -> String


function toLocaleCurrency(currency, amount, fixed) {
  var _find = find(propEq('code', currency))(CURRENCIES),
      prepend = _find.prepend,
      ratio = _find.ratio,
      symbol = _find.symbol;

  return pipe( // divide if necessary
  function (amount) {
    return coins(ratio, amount);
  }, // format the price, e. g. 10000 -> 10,000
  function (amount) {
    return formatPrice(amount, fixed);
  }, // add currency symbol
  function (amount) {
    return currencySymbol(symbol, prepend, amount);
  })(amount);
}

module.exports = toLocaleCurrency;